import type { IUser } from './IUser'
import type { IAddress } from './IAddress';
import type { IFile } from './IFiles';
import type { CategoriesCompanyEnum } from './ICategories';
import type { CurrencyKey } from './ICurrency';
import type { IService } from "./IService";
import type { IIntegration } from './IIntegration';
import type { Countries } from '@ui/components/input/phone/phoneUtils';
import type { ISubscription } from './ISubscription';

export const TimeFormat = {
  Hour12: '12Hour',
  Hour24: '24Hour',
};

type TimeFormatType = typeof TimeFormat[keyof typeof TimeFormat];

export interface IEmailSettings {
  language: string
}

export enum EPaymentProvider {
  TINKOFF = 'tinkoff',
  STRIPE = 'stripe',
}

export enum ETinkoffAddresses {
  LEGAL = 'legal',
  ACTUAL = 'actual',
  POST = 'post',
  OTHER = 'other',
}

export enum EIntegrationDataCeoDocTypes {
  Passport = 'passport',
  ForeignPassport = 'foreignPassport',
}

export interface IClientMerchantDataEntity {
  id: number;
  billingDescriptor: string;
  fullName: string;
  name: string;
  inn: string;
  kpp: string;
  ogrn: string;
  serviceProviderEmail: string | null;
  addresses: {
    type: ETinkoffAddresses;
    zip: string;
    country: string;
    city: string;
    street: string;
  }[];
  email: string;
  siteUrl: string;
  code: string;
  shopCode: string;
  terminals: unknown[];
  ceo: IClientMerchantCeo;
  bankAccount: {
    account: string;
    bankName: string;
    bik: string;
    details: string;
    tax: number;
    korAccount: string;
  };
  provider: EPaymentProvider;
  client: ICompany;
}

export interface IClientMerchantCeo {
  phone: string;
  address: string;
  country: string;
  docType: EIntegrationDataCeoDocTypes;
  issuedBy: string;
  lastName: string;
  birthDate: string;
  docNumber: string;
  firstName: string;
  issueDate: string;
  middleName: string;
}

export interface ICompany {
  id?: number,
  created?: Date | string;
  _tariff?: ISubscription;
  userId?: number,
  isTest?: boolean
  idAlias: string
  users?: IUser[],
  clientName: string,
  clientDescription: string,
  clientUrl: string,
  rules?: string
  calendarTimeStep: number,
  inn: string;
  meta: {
    phone: string;
    email: string;
    category: CategoriesCompanyEnum;
  };
  // & typeof Fields.phoneObjectTemplate,
  addresses: IAddress[];
  services: IService[];
  isEnable: boolean;
  files?: IFile[];
  logoUrl?: string;
  currency: CurrencyKey;
  emailSettings?: IEmailSettings;
  settings?: {
    phoneCountryCode: Countries
    slotPriceVisibility: boolean
    timeFormat: TimeFormatType
  },
  clientIntegrations?: IIntegration[];
  subscriptions?: ISubscription[];
  merchantData?: any;
  merchantDataId?: number | null;
  stripeAccount?: {
    id: string;
    isActive: boolean;
  };
  stripeAccountId?: string | null;
}